import { render, staticRenderFns } from "./ConfigCategoriesMobile.vue?vue&type=template&id=d3f1d898"
import script from "./ConfigCategoriesMobile.vue?vue&type=script&lang=js"
export * from "./ConfigCategoriesMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports